import { useEffect, useState } from "react";

export function useAsyncData<T>(
  deps: unknown[],
  loader: (...args: [AbortSignal, ...unknown[]]) => Promise<T>,
  enabled = true
) {
  const [data, setData] = useState<T | null>(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    if (!enabled) return;

    const controller = new AbortController();
    let mounted = true;

    async function load() {
      setLoading(true);
      setError(null);
      try {
        const result = await loader(controller.signal, ...deps);
        if (mounted) setData(result);
      } catch (err) {
        if (mounted && err instanceof Error && err.name !== "AbortError") {
          setError(err.message);
        }
      } finally {
        if (mounted) setLoading(false);
      }
    }

    load();

    return () => {
      mounted = false;
      controller.abort();
    };
  }, // eslint-disable-next-line react-hooks/exhaustive-deps
  [enabled, JSON.stringify(deps)]);

  return { data, loading, error, refetch: () => {} };
}